export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
